<template>
  <div>
    <el-container>
      <el-main style="padding: 15px 20px 15px">
        <!-- 搜索区域 -->
        <div class="search-wrapper">
          <el-form :inline="true" :model="searchForm" size="mini">
            <el-form-item label="商品编码:">
              <el-input v-model.trim="searchForm.goodsCode" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品名称:">
              <el-input v-model.trim="searchForm.goodsName" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="店铺名称:">
              <el-select v-model="searchForm.storeId" placeholder="请选择">
                <el-option v-for="item in authOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="btn-wrapper">
            <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
            <el-button class="orange-btn" size="mini" @click="handleReset">重置</el-button>
            <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
          </div>
        </div>
      </el-main>
    </el-container>
    <el-container>
      <el-main style="padding: 0 20px 10px 20px">
        <el-table border :data="tableData" :height="tableHeight + 'px'" v-loading="loading" v-if="tableHeight">
          <el-table-column label="图片" width="50px" fixed="left">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" v-if="scope.row.imgUrlList && scope.row.imgUrlList.length" @click="showPicture(scope.row)"
                >查看</el-link
              >
              <el-link :underline="false" disabled v-else>查看</el-link>
            </template>
          </el-table-column>
          <el-table-column label="商品编码" prop="goodsCode" width="150px" fixed="left" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="商品名称" prop="goodsName" min-width="200px" fixed="left" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="直播销量" prop="planLiveSalesResult" width="100px" align="right"></el-table-column>
          <el-table-column label="实际销量" prop="salesResult" width="100px" align="right">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.salesResult > 0 ? '#0bb78e' : '' }">{{ scope.row.salesResult }}</span>
            </template>
          </el-table-column>
          <el-table-column label="截止3日销量" prop="endSalesResult" width="120px" align="right"></el-table-column>
        </el-table>

        <!-- pagination -->
        <div style="overflow: hidden">
          <el-pagination
            style="float: right; margin-top: 10px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total"
          >
          </el-pagination>
        </div>

        <!-- 图片预览 -->
        <pic-video :data="rowData" :detailType="0" ref="picVideo"></pic-video>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import mixin from '@/views/preSalePlan/utils/mixin.js';
import picVideoMixin from '../commodity/pic&video.mixin';

export default {
  name: 'abnormalGoods',
  mixins: [mixin, picVideoMixin],
  props: ['form', 'dataUpdateObj'],
  data() {
    return {
      loading: false,
      searchForm: {
        goodsCode: '',
        goodsName: '',
      },
      storeList: [],
      tableData: [],
      tableHeight: 0,
      paginationOpt: {
        pageSizes: [50, 100, 200, 500],
        pageNum: 1,
        pageSize: 50,
        total: 0,
      },
      rowData: null,
    };
  },
  mounted() {
    this.addListener_refresh();
    this.init();
  },
  methods: {
    addListener_refresh() {
      this.$bus.$off('refresh');
      this.$bus.$on('refresh', (_) => {
        this.tableHeight = 0;
        this.$nextTick((_) => {
          this.handleReset();
        });
      });
    },
    init() {
      this.tableHeight = document.documentElement.clientHeight - 325;
      this.loading = true;
      let data = {
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize,
        filterData: {
          ...this.form,
          ...this.searchForm,
          queryAbnormalGoodsFlag: 1,
        },
      };
      this.$q.preSalePlan.goodsResultListPage({ data }).then(res => {
        if (res.success) {
          this.tableData = res.data.records || [];
          this.paginationOpt.total = res.data.total || 0;
        } else {
          this.tableData = [];
          this.paginationOpt.total = 0;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSearch() {
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleReset() {
      this.searchForm = {
        goodsCode: '',
        goodsName: '',
      };
      this.paginationOpt.pageNum = 1;
      this.paginationOpt.pageSize = 50;
      this.init();
    },
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    // 导出
    async handleExport() {
      let data = {
        ...this.formData,
        storeId: this.form.storeId,
        planTime: this.planTime,
        pageSize: 10000,
        pageNum: 1,
      };
      let params = {
        appCode: 'ec-pc-new',
        paramMap: data,
        reportName: 'goosSubmissionExport',
      };
      this.$q.orderDate.importExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 查看图片
    showPicture(row) {
      this.rowData = row;
      this.$nextTick(() => {
        this.$refs.picVideo.show();
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.search-wrapper
  display flex
  justify-content space-between
  align-items flex-start

.btn-wrapper
  flex-shrink 0

>>> .el-form--inline .el-form-item {
  margin-bottom: 0;
}
</style>
